angular.module("coursemap").component("studentCalendar", {
  templateUrl: "templates/student/calendar_sync.html",
  controller: "studentCalendarCtrl",
  controllerAs: "studentCalendarCtrl",
  bindings: {
    courses: "<"
  }
})
